import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./i18n";
import http from "./http";
import VueCookies from "vue-cookies-ts";
import GSignIn from "./plugins/google-signin";
//import VueCompositionAPI from "@vue/composition-api";
import "./assets/css/style.scss";
import vuetify from "./plugins/vuetify";

Vue.config.productionTip = false;
Vue.prototype.$http = http;
//Vue.use(VueCompositionAPI);
Vue.use(VueCookies);
Vue.cookies.config({ expires: "14d", path: "/" });
Vue.use(GSignIn);

Vue.mixin({
  methods: {
    getStaticFileURL(filename) {
      return `${process.env.VUE_APP_STATIC_URL || "/static"}/` + filename;
    },
    mergeErrorMessages(res: Array<{ status: string }>) {
      return res.map(item => i18n.t(item.status)).join("\n");
    },
    getWSURL() {
      if (process.env.NODE_ENV === "development")
        return "ws://localhost:5000/ws";
      return `wss://${window.location.host}/ws`;
      /*
      const protocol =
        process.env.NODE_ENV === "development" ? "ws://" : "wss://";
      return `${protocol}${window.location.host}/ws`;
      
      if (process.env.VUE_APP_DOMAIN_NAME)
        return `wss://${process.env.VUE_APP_DOMAIN_NAME}/ws`;
      return "ws://localhost:5000/ws";
      */
    },
    dateFormat(date: string) {
      if (!date.endsWith("z")) date = date + "z";
      return new Date(date).toLocaleString(i18n.locale);
    }
  }
});

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: h => h(App)
}).$mount("#app");
